import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { SuperAdminRole } from '@municipality/types';
import { Spin } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: SuperAdminRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles 
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If no specific roles required, allow access
  if (!requiredRoles || requiredRoles.length === 0) {
    return <>{children}</>;
  }

  // Check if user has required role
  // Fallback: if user has role super_admin but no superAdminRole (e.g. just activated), treat as SUPER_ADMIN for full access
  const userRole = (user as { superAdminRole?: string; role?: string })?.superAdminRole as SuperAdminRole | undefined;
  const effectiveRole = userRole || ((user as { role?: string })?.role === 'super_admin' ? SuperAdminRole.SUPER_ADMIN : undefined);

  if (!effectiveRole || !requiredRoles.includes(effectiveRole)) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};
